import { SITE_ORIGIN } from '../../../constants/site';
import { AVANCE_LANDING_COPY, AVANCE_LANDING_ANGLES } from '../../../constants/landingPagesCopy/avanceImmediate_messages.fr';
import { AVANCE_LANDING_PATHS } from '../../../constants/landingPagesConfig/avanceImmediate';
import { LANDING_MOTION } from '../../../constants/landingMotion';
import { LANDING_HOST, PREVIEW_LOCAL_HOSTS } from '../../../constants/landingHosts';
import { NEOCALCUL_LANDING_PATH } from '../../../constants/neocalculLanding';
import { NEOCALCUL_LANDING_ANGLES, NEOCALCUL_LANDING_COPY } from '../../../constants/landingPagesCopy/neocalcul_messages.fr';

export const LANDING_PRIMARY_HOST = new URL(SITE_ORIGIN).hostname;
export const LANDING_LOCAL_HOSTS = PREVIEW_LOCAL_HOSTS;

const avance = (variant, indexed) => Object.freeze({
  id: `avance-immediate-${variant}`, funnel: 'avance_immediate', component: 'avanceImmediate', variant, hero: variant,
  tones: Object.freeze(variant === 'cinematic'
    ? { simulator: 'light', flow: 'dark', eligibility: 'light' }
    : { simulator: 'dark', flow: 'light', eligibility: 'dark' }),
  pinOffset: variant === 'professional' ? LANDING_MOTION.navHeight : 0,
  path: AVANCE_LANDING_PATHS[variant], host: null,
  previewPath: `/l/${AVANCE_LANDING_PATHS[variant].slice(1)}`,
  canonical: new URL(AVANCE_LANDING_PATHS[variant], SITE_ORIGIN).href,
  indexed, schema: indexed ? 'software' : null, paidOffer: true, ownsFooter: true,
  seoTitle: variant === 'cinematic' ? AVANCE_LANDING_COPY.seo.cinematicTitle : AVANCE_LANDING_COPY.seo.professionalTitle,
  activation: 'urssaf_demand', authSkin: 'avance_immediate', relatedFeature: 'facturation',
  defaultAngle: 'tarif', angles: AVANCE_LANDING_ANGLES, copy: AVANCE_LANDING_COPY,
  source: 'src/features/marketing/landings/avanceImmediate/AvanceImmediateLanding.js',
});

// Free station: no paid offer in its schema, no related band (Espace Famille is TODO).
const neocalcul = Object.freeze({
  id: 'neocalcul', funnel: 'neocalcul', component: 'neocalcul', variant: 'host',
  path: '/', host: LANDING_HOST.CALCUL, previewPath: NEOCALCUL_LANDING_PATH,
  canonical: new URL('/', `https://${LANDING_HOST.CALCUL}`).href,
  indexed: true, schema: 'software', paidOffer: false, ownsFooter: false, seoTitle: NEOCALCUL_LANDING_COPY.seo.title,
  activation: 'calcul_series', relatedFeature: null,
  defaultAngle: 'rituel', angles: NEOCALCUL_LANDING_ANGLES, copy: NEOCALCUL_LANDING_COPY,
  source: 'src/features/marketing/neocalcul/NeoCalculLanding.js',
});

export const LANDING_PAGES = Object.freeze([avance('cinematic', false), avance('professional', true), neocalcul]);
export const landingById = (id) => LANDING_PAGES.find((entry) => entry.id === id) || null;
export const landingByPath = (pathname) => LANDING_PAGES.find((entry) => !entry.host
  && (entry.path === pathname || entry.previewPath === pathname)) || null;
export const landingWwwPaths = () => LANDING_PAGES.filter((entry) => !entry.host).map((entry) => entry.path);
/** Shell page key: the path on www, `/__host/<host><path>` on a landing host (its `/` is not the home page). */
export const landingPageKey = (entry) => (entry.host ? `/__host/${entry.host}${entry.path === '/' ? '' : entry.path}` : entry.path);
export const landingByPageKey = (key) => LANDING_PAGES.find((entry) => landingPageKey(entry) === key) || null;
export const isLandingHost = (hostname, entries = LANDING_PAGES) => entries.some((entry) => entry.host && entry.host === hostname);
/** Per-host prerendered routes, `{host, route, indexed}` (same shape as the Formations routes). */
export const landingHostRoutes = (entries = LANDING_PAGES) => entries.filter((entry) => entry.host)
  .map((entry) => ({ host: entry.host, route: entry.path, indexed: entry.indexed }));
